module.exports = "/static/assets/af40e1882a7506b7830318c482d708e5.png";